// extracted by mini-css-extract-plugin
export var fullHeightState = "_1b-7";
export var headerCell = "_1b-1";
export var loadingStateCell = "_1b-4";
export var rowWrapper = "_1b-3";
export var standaloneTable = "_1b-8";
export var standaloneTableWithBodyFill = "_1b-9";
export var stateCell = "_1b-5";
export var table = "_1b-0";
export var tableBodyFiller = "_1b-6";
export var white = "_1b-2";